import { render } from "./ProposalsDashboard.vue?vue&type=template&id=5732534a&scoped=true"
import script from "./ProposalsDashboard.vue?vue&type=script&lang=js"
export * from "./ProposalsDashboard.vue?vue&type=script&lang=js"

import "./ProposalsDashboard.vue?vue&type=style&index=0&id=5732534a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5732534a"]])

export default __exports__